import SelfCareApi from "@/services/api/selfcare-api";
import moment from "moment";

const state = {
  accountInfo: {},
  packageInfo: {}, // current package information
};

const getters = {
  accountInfo(state: { accountInfo: any }) {
    return state.accountInfo;
  },
  packageInfo(state: { packageInfo: any }) {
    return state.packageInfo;
  },
};

const actions = {
  async FETCH_ACCOUNT_INFO(context: { commit: (arg0: string, arg1: any) => void }) {
   return await SelfCareApi.fetchAccountInfo()
    .then((response) => {
      //console.log("Resp::", response)
      context.commit("SET_ACCOUNT_INFO", response);
      return response;
    }).catch((error)=>{
      throw error.response;
    });
  },

  async FETCH_PACKAGE_INFO(context: { commit: (arg0: string, arg1: any) => void }) {
    return await SelfCareApi.fetchPackageInfo().then((response) => {
      // console.log("Package Info::", response)
      context.commit("SET_PACKAGE_INFO", response);
      return response;
    }).catch((error)=>{
      throw error.response;
    });
  },
};

const mutations = {
  SET_ACCOUNT_INFO(state: { accountInfo: any }, payload: any) {
    state.accountInfo = payload;
  },

  SET_PACKAGE_INFO(state: { packageInfo: any }, payload: any) {
    state.packageInfo = payload;
  },
};

export default {
  namespace: true,
  state,
  actions,
  mutations,
  getters,
};
